import React from 'react'
import styles from './not-found.module.css'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const NotFound: React.FC = props => {
  const {t} = useTranslation()

return <div className={''}>
  <h1 className="darkBlue">404</h1>
  <h2>{t("errors.404.title")}</h2>
  <p>{t("errors.404.message")}</p>
  <div className={styles.footerButtons}>
    <div className={`${styles.link} btn` }>
      <Link to={"/"} className="link"><span>{t("Jou​rney​-planner")}</span></Link>
    </div>
    <div className={`${styles.link} btn` }>
      <Link to={"/"} className="link">{t("Customer-service")}</Link>
    </div>
    <div className={`${styles.link} btn` }>
      <Link to={"/"} className="link">{t("Lines-and-stations")}</Link>
    </div>
  </div>
</div>
}
export default NotFound